import { render, staticRenderFns } from "./LtiRegistration.vue?vue&type=template&id=1cc8c1d0&scoped=true&"
import script from "./LtiRegistration.vue?vue&type=script&lang=ts&"
export * from "./LtiRegistration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc8c1d0",
  null
  
)

export default component.exports